<template>
  <div class="quote__invent">
    <p>
      <span>{{member.firstName}} {{member.lastName}}</span>
    </p>
    <ul>
      <li v-if="!isPolicyHolder"> {{ member.relationName}} </li>
      <li v-else> {{$t('qic_quote_policy_holder')}} </li>
      <li v-if="formattedDateOfBirth">{{$t('qic_user_dob')}}: {{ formattedDateOfBirth }}</li>
      <li v-if="member.passportNo || member.qatar_id">{{$t('qic_quote_member_qid')}}: {{ member.passportNo || member.qatar_id }}</li>
      <li v-if="member.genderName ">{{$t('qic_quote_member_gender')}}: {{ member.genderName }}</li>
      <li v-if="member.nationalityName">{{$t('qic_quote_member_nationality')}}: {{ member.nationalityName }}</li>
    </ul>
  </div>
</template>

<script>
import { formatDate } from '../../utils/formatDate'

export default {
  name: 'QuoteInsuredMember',
  props: {
    member: { type: Object }
  },
  data () {
    return {
      locale: this.$i18n.locale || 'en'
    }
  },
  computed: {
    formattedDateOfBirth () {
      return formatDate(this.member.dateOfBirth, this.locale, 'dd.MM.yyyy')
    },
    isPolicyHolder () {
      return this.member.id === '0'
    }
  },
  methods: {
  },
  mounted () {
    console.log(this.member)
  }
}
</script>
